
import { useState,useEffect,useRef } from 'react';
import { Space, Table, Tag, Button, Input,Switch,message,Empty } from 'antd';
import type { TableProps } from 'antd';
import { useNavigate } from "react-router-dom"
import ProductItem from './components/productsEdit';
import { DataType, column } from './column';
import { supplyProduct,changeSupplyProductStatus,supplyProductTypes,SupplyProductType } from '@/services/supplyProduct';
import { ResDataType } from '@/services/ajax';
import useSearchTable from '@/hooks/useList';
import MenuPermissionControl from '@/components/menuPermissionControl';
import useGetCurMenuId from '@/hooks/useGetCurMenuId';

export default function ProductsPage() {
  const nav = useNavigate();
  const { menuId } = useGetCurMenuId();
  const dialog = useRef<any>(null);
  const [typeList,setTypelist] = useState<SupplyProductType[]>([]);
  const defaultValue = {
    ProductName: ''
  }
  const {
    data,
    total,
    loading,
    fetchData,
    searchParams,
    handleSearch,
    handlePageChange
  } = useSearchTable(supplyProduct, defaultValue );
  
  const search = (e:any)=>{
    handleSearch({ProductName: e.target.value})
  }
  const getTypeList = async () => {
      const res = await supplyProductTypes() as ResDataType;
      setTypelist(res.data.list);
  }

  const productTypeTransform = (value:string) => {
    if (!value) {
      return '';
    }
    const type = typeList.find((item:SupplyProductType) => item.value == value);
    return type? type.description : '';
  }

  
    const columns: TableProps<DataType>['columns'] = [
     ...(column || []),
      // {
      //   title: '权益活动类型',
      //   dataIndex: 'productType',
      //   key: 'productType', 
      //   width: 100,
      //   render: (_, record) => (
      //     <Tag color="blue">{productTypeTransform(record.productType)}</Tag>
      //   )
      // },
      {
        title: '权益活动状态',
        dataIndex: 'status',
        key: 'status',
        width:50,
        render: (_, record) => (
          <Tag color={record.status == 0 ? 'green' : 'red'}>
            {record.status == 0 ? '上架' : '下架'}
          </Tag>
        )
      },
      {
        title: '操作',
        key: 'action',
        fixed: 'right',
        render: (_, record) => (
          <MenuPermissionControl menuId={menuId} operation="edit" >
            <Space size="middle">
              <Button onClick={()=> {
                openDialog('edit',record)
              }}>编辑</Button>
              {/* <Popconfirm
                title="提示"
                disabled={record.status == 0}
                description="确定删除该商品吗?"
                onConfirm={()=> deletePro(record.id)}
                okText="确定"
                cancelText="取消"
              >
                <Button disabled={record.status == 0} danger>删除</Button>
              </Popconfirm> */}
              <Switch checkedChildren="已上架" unCheckedChildren="已下架" onChange={(e)=>{
                handleChangeStatus(record.id,e?0:1)
              }} checked={record.status == 0 ? true : false}  />
            </Space>
          </MenuPermissionControl>
        ),
      },
    ];

    useEffect(()=> {
      getTypeList();
    },[])

    const openDialog = (type:string,record?:DataType) => {
      dialog.current?.open(type,record);
    }

    const handleChangeStatus = async (productId:number,status:number) => {
      const res = await changeSupplyProductStatus({supplyProductId:productId,status}) as ResDataType;
      if (res.code != 0) {
        message.error(res.message);
        return;
      }
      handleSearch();
    }
  
  return (
    <>
      <div className="headerTitle">
        <div>
          <h2>权益活动管理</h2>
        </div>
        
      </div>

      <div className="card">
        <div className="searchCond">
          <Space size='middle'>
            <Input style={{ width:'250px' }} allowClear placeholder="权益活动名称"  onPressEnter={search} size='large' onChange={search}/>
            
              <Button type="primary" size='large' onClick={()=>{ fetchData() }}>搜索</Button>
            
            <Button type="primary" size='large' onClick={()=>{ nav('/main/activities') }}>权益包管理</Button>
            <MenuPermissionControl menuId={menuId} operation="edit" >
              <Button type="primary" size='large' className="btn" onClick={()=> openDialog('add')}>
                添加权益活动
              </Button>
            </MenuPermissionControl>
          </Space>
        </div>

        <div className="overflow-x-auto">
          <Table<DataType>
            rowKey='id'
          columns={columns} 
          dataSource={data as DataType[]}
          loading={loading}
          pagination={{ current: searchParams.PageIndex, pageSize:searchParams.PageSize, total, onChange: handlePageChange,showSizeChanger:false  }}
          scroll={{ x: 'max-content', y: 580 }}
          locale={{ emptyText: <Empty description="暂无数据"></Empty> }}
          />
        </div>
      </div>
      <ProductItem ref={dialog} save={handleSearch}/>
    </>
  );
} 